import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "popover__head" }
const _hoisted_2 = { class: "popover__title" }
const _hoisted_3 = {
  key: 0,
  class: "popover__move"
}
const _hoisted_4 = { class: "popover__move-grid" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "popover__foot" }
const _hoisted_7 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "popover-layer",
    onPointerdown: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.$emit('close')), ["self"]))
  }, [
    _createElementVNode("div", {
      ref: "card",
      class: "popover",
      style: _normalizeStyle(_ctx.positionStyle),
      role: "dialog",
      "aria-modal": "true",
      onKeydown: _cache[6] || (_cache[6] = _withKeys(_withModifiers(($event: any) => (_ctx.$emit('close')), ["stop","prevent"]), ["esc"]))
    }, [
      _createElementVNode("header", _hoisted_1, [
        _createElementVNode("span", {
          class: "popover__dot",
          style: _normalizeStyle({ background: _ctx.accent })
        }, null, 4),
        _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.headTitle), 1),
        _createElementVNode("button", {
          class: "popover__x",
          type: "button",
          "aria-label": "Закрыть",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
        }, " × ")
      ]),
      _withDirectives(_createElementVNode("textarea", {
        ref: "input",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.draft) = $event)),
        class: "popover__input",
        rows: "2",
        placeholder: "Что нужно сделать?",
        onKeydown: _cache[2] || (_cache[2] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["exact","prevent"]), ["enter"]))
      }, null, 544), [
        [_vModelText, _ctx.draft]
      ]),
      (_ctx.mode === 'edit')
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _cache[8] || (_cache[8] = _createElementVNode("span", { class: "popover__move-label" }, "Переместить в", -1)),
            _createElementVNode("div", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.otherQuadrants, (q) => {
                return (_openBlock(), _createElementBlock("button", {
                  key: q.id,
                  type: "button",
                  class: "popover__move-btn",
                  style: _normalizeStyle({ '--c': q.accent }),
                  onClick: ($event: any) => (_ctx.$emit('move', q.id))
                }, _toDisplayString(q.title), 13, _hoisted_5))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("footer", _hoisted_6, [
        (_ctx.mode === 'edit')
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              class: "popover__btn popover__btn--danger",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('delete')))
            }, " Удалить "))
          : _createCommentVNode("", true),
        _cache[9] || (_cache[9] = _createElementVNode("span", { class: "popover__spacer" }, null, -1)),
        _createElementVNode("button", {
          type: "button",
          class: "popover__btn popover__btn--ghost",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('close')))
        }, " Отмена "),
        _createElementVNode("button", {
          type: "button",
          class: "popover__btn popover__btn--primary",
          disabled: !_ctx.draft.trim(),
          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)))
        }, " Сохранить ", 8, _hoisted_7)
      ])
    ], 36)
  ], 32))
}